import React from 'react';

// import { useNavigate } from 'react-router';
import styled from '@emotion/styled';

// import { DASHBOARD } from '../../../../routes/routeConstants';
import TranslatingContainer from '../../../TranslatingContainer/TranslatingContainer';
import ModalContainer from '../../ModalContainer';
// import { ModalContext } from '../../ModalContext';
// import PlainSuccessModal from '../../PlainSuccessModal';
import ConfirmCreateDispatcher from './ConfirmCreateDispatcher';
import CreateDispatcher from './CreateDispatcher';
import SubmitCreateDispatcher from './SubmitCreateDispatcher';

interface HireDispatcherModalProps {
  dispatcherData: any;
}
const HireDispatcherModal: React.FC<HireDispatcherModalProps> = ({
  dispatcherData,
}) => {
  // const modalContext = useContext(ModalContext);
  // const navigate = useNavigate();
  // const successActionFn = () => {
  //   modalContext?.setShowModal(!modalContext?.showModal);
  //   navigate(`/${DASHBOARD}`);
  // };

  return (
    <Container>
      <ModalContainer
        label='Hire Driver'
        // successComponent={() => (
        //   <PlainSuccessModal
        //     successActionFn={successActionFn}
        //     description='The driver has been successfully hired.'
        //     btnLabel='Go to Dashboard'
        //   />
        // )}
        // showSuccessComponent={modalContext?.showSuccessComponent}
      >
        <FormContainer>
          <TranslatingContainer>
            <ConfirmCreateDispatcher dispatcherData={dispatcherData} />
            <CreateDispatcher />
            <SubmitCreateDispatcher dispatcherData={dispatcherData} />
          </TranslatingContainer>
        </FormContainer>
      </ModalContainer>
    </Container>
  );
};

export default HireDispatcherModal;

const Container = styled.div`
  flex-direction: column;
  gap: 12px;
  display: flex;
`;

const FormContainer = styled.div`
  display: flex;
  overflow: hidden;

  @media (max-width: 884px) {
    width: 100%;
  }
`;
